import Header from 'components/Header';
import { Row, Col } from 'react-bootstrap';
import { Search } from 'common/Search';
import { Filter } from 'common/Filter';
import { FILTERS } from 'pages/Bookings/constant';
import PageContainer from 'common/PageContainer';
import ReviewText from './ReviewText';
import DropdownReview from './DropdownReview';

const GridFilterBar = ({
  filterCriteria,
  handleSearch,
}: {
  filterCriteria: any;
  handleSearch: (searchTerm: string) => void;
}) => (
  <Row className="mb-2 mt-2">
    <Col sm={12} md={4}>
      <Search searchKeyword='' onSearch={handleSearch} />
    </Col>
    <Col sm={12} md={1} className="d-flex align-items-center">
      <Filter filterCriteria={filterCriteria} />  
    </Col>
    <Col sm={12} md={4}>
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center me-4">
          <div
            className="rounded-circle me-2"
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: '#28A745',
            }}
          ></div>
          <p className="mb-0">Good</p>
        </div>

        <div className="d-flex align-items-center me-4">
          <div
            className="rounded-circle me-2"
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: '#FFC107',
            }}
          ></div>
          <p className="mb-0">Average</p>
        </div>

        <div className="d-flex align-items-center">
          <div
            className="rounded-circle me-2"
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: '#D02429',
            }}
          ></div>
          <p className="mb-0">Bad</p>
        </div>
      </div>
    </Col>
  </Row>
);

const Feedback = () => {
  const handleSearchChange = (searchTerm: string) => {
    console.log('Search term:', searchTerm);
    // Implement search logic here
  };

  const review =
    'combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc';

  return (
    <PageContainer>
      <Header totalCount={null} heading={'Feedback'} />
      <GridFilterBar
        filterCriteria={FILTERS}
        handleSearch={handleSearchChange}
      />
      <div className="box-height border p-3 mx-2 "  >
        <Row className="gx-3 gy-3">
          <Col sm={12} md={6}>
            <div
              className="border rounded p-3 feed_success_border"
            >
              <Row className="d-flex justify-content-between p-3">
                <Col>
                  <div className="d-flex">
                    <img
                      src="https://images.rawpixel.com/image_png_800/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIyLTA4L2pvYjEwMzQtZWxlbWVudC0wNy00MDMucG5n.png"
                      className="border rounded-circle feed_profile_Image"
                      alt='Not Found'
                    />
                    <div className="ms-3 mt-3">
                      <h6 className="mb-0 fw-bold">Hitendra Jajoriya</h6>
                      <small className="">Rattam, MP</small>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-3 mt-3">
                    <div>
                      <small>Chef: Rahul Vishwakarma</small>
                      <br />
                      <small>Date: 02/03/2025</small>
                      <br />
                      <small>Time: 2:00PM</small>
                    </div>
                  </div>
                </Col>
                <Col className="text-start">
                  <div className="d-flex justify-content-between">
                    <div className="text-warning ">
                      <i className="bi bi-star-fill me-2 fs-4"></i>
                      <i className="bi bi-star-fill me-2 fs-4"></i>
                      <i className="bi bi-star-fill me-2 fs-4"></i>
                      <i className="bi bi-star me-2 fs-4"></i>
                      <i className="bi bi-star me-2 fs-4"></i>
                      <small className="text-secondary">20/06/2025</small>
                    </div>
                    <DropdownReview />
                  </div>
                  {/* <DropdownReview /> */}
                  <ReviewText text={review} />
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-sm ps-3 pe-3 px-1 rounded-pill feed_Button"
                    >
                      View Booking
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm ps-3 pe-3 px-1 rounded-pill feed_Button"
                    >
                      View Chef
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm ps-4 pe-4 rounded-pill px-1 feed_Button"
                    >
                      Reply
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </PageContainer>
  );
};

export default Feedback;
